import { scrollTo } from 'scroll-js';
import viewportContainer from './viewportContainer'

const scrollToAnchor = (str) => {
  if (!str) {
    console.log('No anchor to scroll to.')
    return
  }

  const el = document.getElementById(str.replace('#', ''))

  if (!el) {
    return
  }

  const rect = el.getBoundingClientRect()

  document.body.style.overflow = 'hidden'
  window._IS_AUTO_SCROLLING = true

  const offset = viewportContainer.vw < 768 ? 300 : 0

  const top = rect.top + viewportContainer.y + offset
  const duration = Math.max(300, Math.min(800, rect.top / 5))

  scrollTo(window, { 
    top,
    duration,
    easing: 'ease-out',
  }).then(() => {
    document.body.style.overflow = 'auto'
    window._IS_AUTO_SCROLLING = false
  });
}

export default scrollToAnchor